<template>
	<div class="setTactics">
		<div class="line"></div>
		<div class="one">
			<el-container>
				<el-aside width="60%">
					<span class="caption">策略名称</span>
					<el-input :readonly="isInput" v-model="tacticsName"></el-input>
				</el-aside>
				<el-main width="40%">
					<span class="caption">策略分类</span>
					<el-input :readonly="isInput" v-model="tacticsClass"></el-input>
				</el-main>
			</el-container>
			<div>
				<span class="caption">备注信息</span>
				<el-input :readonly="isInput" v-model="remark" type="textarea" autosize></el-input>
			</div>
		</div>
		<div class="two">
			<div class="headline clearfix">
				<div class="caption_line fl"></div>
				<span class="fl">初始通知详情</span>
			</div>
			<div>
				<div>
					<span class="caption">通知人员</span>
					<el-input :readonly="isInput" v-model="informPerson"></el-input>
				</div>
				<el-row>
					<el-col :span="8">
						<span class="caption">通知方式</span>
						<el-input :readonly="isInput" v-model="infomWay"></el-input>
					</el-col>
					<el-col :span="8">
						<span class="caption">通知效果</span>
						<el-input :readonly="isInput" v-model="infomResult"></el-input>
					</el-col>
					<el-col :span="8">
						<span class="caption">失败条件</span>
						<el-input :readonly="isInput" v-model="errorCondition"></el-input>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<span class="caption">失败次数</span>
						<el-input :readonly="isInput" v-model="errorNum"></el-input>
					</el-col>
					<el-col :span="8" class="chk">
						<el-checkbox v-model="isGo">失败后是否继续通知</el-checkbox>
					</el-col>
					<el-col :span="8">
						<div class="time">
							<span class="caption">时间间隔</span>
							<el-input :readonly="isInput" v-model="interval" class="min"></el-input>
							<span>{{timeUnit}}</span>
						</div>
					</el-col>
				</el-row>

			</div>
		</div>
		<div class="three">
			<div class="headline clearfix">
				<div class="caption_line fl"></div>
				<span class="fl">通知方式升级</span>
			</div>
			<div class="upgrade" v-for="(item,index) in items">
				<div class="upgrade_head">
					<el-row>
						<el-col :span="6" class="chk">
							<span>{{item.text + (index+1)}}</span>
						</el-col>
						<el-col :span="12">
							<span class="caption">唯一码</span>
							<span>{{item.uuid}}</span>
						</el-col>
						<el-col :span="6">
							<span class="caption">升级序号</span>
							<el-input :readonly="isInput" class="min" v-model="item.index"></el-input>
						</el-col>
					</el-row>
				</div>
				<div class="upgrade_content">
					<el-row>
						<el-col :span="8">
							<span class="caption">通知方式</span>
							<el-input :readonly="isInput" v-model="item.infomWay"></el-input>
						</el-col>
						<el-col :span="8">
							<span class="caption">通知效果</span>
							<el-input :readonly="isInput" v-model="item.infomResult"></el-input>
						</el-col>
						<el-col :span="8">
							<span class="caption">失败条件</span>
							<el-input :readonly="isInput" v-model="item.errorCondition"></el-input>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="8">
							<span class="caption">通知次数</span>
							<el-input :readonly="isInput" tv-model="item.infomNum"></el-input>
						</el-col>
						<el-col :span="8" class="chk">
							<el-checkbox v-model="item.isGoUpgrade" @change="defeated1(item.isGoUpgrade,index)">失败后是否继续通知</el-checkbox>
						</el-col>
						<el-col :span="8">
							<div class="time">
								<span class="caption">时间间隔</span>
								<el-input :readonly="isInput" v-model="item.interval" class="min"></el-input>
								<span>{{item.timeUnit}}</span>
							</div>
						</el-col>
					</el-row>
				</div>
			</div>
		</div>

		<!--通知人员-->
		<div class="three">
			<div class="headline clearfix">
				<div class="caption_line fl"></div>
				<span class="fl">通知人员升级</span>
				<!--<div class="fr">
					<el-button @click="addLinkMan">添加</el-button>
					<el-button @click="removeLinkMan">删除</el-button>
				</div>-->
			</div>
			<div class="linkMan" v-for="(item,index) in linkMan">
				<div class="upgrade_head">
					<el-row>
						<el-col :span="6" class="chk">
							<span>{{item.text + (index+1)}}</span>
						</el-col>
						<el-col :span="12">
							<span class="caption">唯一码</span>
							<span>{{item.uuid}}</span>
						</el-col>
						<!--<el-col :span="6">
							<span class="caption">升级序号</span>
	  						<el-input :readonly="isInput" class="min" v-model="item.index"></el-input>
						</el-col>-->
					</el-row>
				</div>
				<div class="upgrade_content">

					<el-row>
						<el-col :span="24">
							<div>
								<span class="caption">通知人员</span>
								<el-input :readonly="isInput" v-model="item.name"></el-input>
							</div>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<span class="caption">升级条件</span>
							<span>通知次数超过</span>
							<el-input :readonly="isInput" value="升级条件" class="min2"></el-input>
							<span>没有响应后，方式升级</span>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="8">
							<span class="caption">通知方式</span>
							<el-input :readonly="isInput" v-model="item.infomWay"></el-input>
						</el-col>
						<el-col :span="8">
							<span class="caption">通知效果</span>
							<el-input :readonly="isInput" v-model="item.infomResult"></el-input>
						</el-col>
						<el-col :span="8">
							<span class="caption">失败条件</span>
							<el-input :readonly="isInput" v-model="item.errorCondition"></el-input>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="8">
							<span class="caption">通知次数</span>
							<el-input :readonly="isInput" tv-model="item.infomNum"></el-input>
						</el-col>
						<el-col :span="8" class="chk">
							<el-checkbox v-model="item.isGoUpgrade" @change="defeated1(item.isGoUpgrade,index)">失败后是否继续通知</el-checkbox>
						</el-col>
						<el-col :span="8">
							<div class="time">
								<span class="caption">时间间隔</span>
								<el-input :readonly="isInput" v-model="item.interval" class="min"></el-input>
								<span>{{item.timeUnit}}</span>
							</div>
						</el-col>
					</el-row>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "setTactics",
		data() {
			return {
				isInput: true,
				isGo: true, //失败后是否继续通知复选框
				items: [],
				linkMan: [],
				arr1: [],
				arr2: [],
				loading: true,
				//one
				tacticsName: '', //策略名称
				tacticsClass: '', //策略分类
				remark: '', //备注信息
				//初始通知详情
				informPerson: '', //通知人员
				infomWay: '', //通知方式
				infomResult: '', //通知效果
				errorCondition: '', //失败条件
				errorNum: '', //失败次数
				interval: '', //时间间隔
				timeUnit: '', //判断是分钟还是小时
				//通知方式升级

			}
		},
		watch: {
			isGo(val) {
				console.log(val);
				console.log(this.instanceId)
			},
			upgrade(val) {
				console.log(val)
			},
		},
		props: {
			instanceId: {
				type: Object,
				default: ''
			},
		},
		//		inject: ['say'],
		created() {
			//this.create()
		},
		methods: {
			init() {
				var obj = this.instanceId;
				//one
				this.tacticsName = obj.Policy.NAME;
				this.tacticsClass = obj.Policy.POLICYTYPENAME;
				this.remark = obj.Policy.MEMO;
				//two
				this.informPerson=""
				for(var i = 0; i < obj.ListInitialNoticeUser.length; i++) {
					if(obj.ListInitialNoticeUser.length <= 1) {
						this.informPerson += obj.ListInitialNoticeUser[i].USERNAME
					} else {
						this.informPerson += obj.ListInitialNoticeUser[i].USERNAME + ','
					}
				};
				this.infomWay = this.manner(obj.InitialNotice.NOTICETYPE);
				this.infomResult = this.require(obj.InitialNotice.NOTICERESULT, 0);
				this.errorCondition = this.require(obj.InitialNotice.NOTICERESULT, 1);
				this.errorNum = obj.InitialNotice.CONTINUOUSCOUNT;
				if(obj.InitialNotice.ISCONTINUE == 1) {
					this.isGo = true
				} else {
					this.isGo = false
				};
				this.interval = obj.InitialNotice.TIMEVALUE;
				if(obj.InitialNotice.TIMEUNIT == 0) {
					this.timeUnit = "分钟"
				} else {
					this.timeUnit = "小时"
				};
				this.items=[]
				//通知方式升级
				for(var i = 0; i < obj.ListUpgradeNotice.length; i++) {
					this.items.push({
						uuid: obj.ListUpgradeNotice[i].UUID.replace(/-/g, ''),
						text: "通知方式升级",
						isGoUpgrade: obj.ListUpgradeNotice[i].ISCONTINUE == 1 ? true : false, //失败后是否继续通知
						id: this.guid(),
						infomWay: this.manner(obj.ListUpgradeNotice[i].NOTICETYPE),
						infomResult: this.require(obj.ListUpgradeNotice[i].NOTICERESULT, 0),
						errorCondition: this.require(obj.ListUpgradeNotice[i].NOTICERESULT, 1),
						infomNum: obj.ListUpgradeNotice[i].CONTINUOUSCOUNT,
						interval: obj.ListUpgradeNotice[i].TIMEVALUE,
						timeUnit: obj.ListUpgradeNotice[i].TIMEUNIT == 0 ? "分钟" : "小时",
						index: obj.ListUpgradeNotice[i].DISORDER
					})
				};
				this.linkMan=[]
				//通知人员升级
				for(var i = 0; i < obj.ListUpgradeHighLevel.length; i++) {
					this.linkMan.push({
						name: this.forEach(obj.ListUpgradeHighLevel[i].ListHighLevelUser),
						uuid: obj.ListUpgradeHighLevel[i].UpgradeHighLevel.UUID.replace(/-/g, ''),
						text: "通知方式升级",
						isGoUpgrade: obj.ListUpgradeHighLevel[i].UpgradeHighLevel.ISCONTINUE == 1 ? true : false, //失败后是否继续通知
						id: this.guid(),
						infomWay: this.manner(obj.ListUpgradeHighLevel[i].UpgradeHighLevel.NOTICETYPE),
						infomResult: this.require(obj.ListUpgradeHighLevel[i].UpgradeHighLevel.NOTICERESULT, 0),
						errorCondition: this.require(obj.ListUpgradeHighLevel[i].UpgradeHighLevel.NOTICERESULT, 1),
						infomNum: obj.ListUpgradeHighLevel[i].UpgradeHighLevel.CONTINUOUSCOUNT,
						interval: obj.ListUpgradeHighLevel[i].UpgradeHighLevel.TIMEVALUE,
						timeUnit: obj.ListUpgradeHighLevel[i].UpgradeHighLevel.TIMEUNIT == 0 ? "分钟" : "小时",
					})
				};
			},
			forEach(arr) {
				var val = '';
				for(var i = 0; i < arr.length; i++) {
					if(arr.length <= 1) {
						val += arr[i].USERNAME
					} else {
						val += arr[i].USERNAME + ','
					}
				}
				return val
			},
			clear() {
				this.items = [];
				this.linkMan = [];
			},
			manner(val) {
				switch(val) {
					case 0:
						val = "IM";
						break;
					case 1:
						val = "微信";
						break;
					case 2:
						val = "短信";
						break;
					case 3:
						val = "电话";
						break;
					default:
						val = "未知";
						break;
				}
				return val
			},
			require(val, id) { //0通知效果，1失败条件
				if(id == 0) {
					switch(val) {
						case 0:
							val = "送出";
							break;
						case 1:
							val = "送达";
							break;
						case 2:
							val = "回复";
							break;

						default:
							val = "未知";
							break;
					}
				} else if(id == 1) {
					switch(val) {
						case 0:
							val = "";
							break;
						case 1:
							val = "未送达";
							break;
						case 2:
							val = "未回复";
							break;

						default:
							val = "未知";
							break;
					}
				}

				return val
			},
			addIndex(i) {
				return i + 1
			},
			add() {
				this.items.push({
					text: "通知方式升级",
					isGoUpgrade: true,
					upgrade: false,
					index: '',
					id: this.guid()
				});
				for(var i = 0; i < this.items.length; i++) {
					this.items[i].index = i + 1
				};
				console.log(this.items)
			},
			remove() {
				for(var i = 0; i < this.items.length; i++) {
					for(var j = 0; j < this.arr1.length; j++) {
						if(this.items[i].id == this.arr1[j]) {
							this.items.splice(i, 1)
						}
					}
				};
				this.arr1 = []
				console.log(this.items);
			},
			upgrade(val, index, id) { //通知方式升级添加
				if(val) {
					this.arr1.push(id)
				} else {
					for(var i = 0; i < this.arr1.length; i++) {
						if(this.arr1[i] == id) {
							this.arr1.splice(i, 1)
						}
					}
				}
				console.log(this.arr1)
			},

			//通知人员升级
			addLinkMan() {
				this.linkMan.push({
					text: "通知人员升级",
					isGoLinkMan: false,
					LinkMan: true,
					index: '',
					id: this.guid()
				})
				for(var i = 0; i < this.linkMan.length; i++) {
					this.linkMan[i].index = i + 1
				}
			},
			removeLinkMan() {
				for(var i = 0; i < this.linkMan.length; i++) {
					for(var j = 0; j < this.arr2.length; j++) {
						if(this.linkMan[i].id == this.arr2[j]) {
							this.linkMan.splice(i, 1)
						}
					}
				};
				this.arr2 = []
			},
			linkManChange(val, index, id) {
				if(val) {
					this.arr2.push(id)
				} else {
					for(var i = 0; i < this.arr2.length; i++) {
						if(this.arr2[i] == id) {
							this.arr2.splice(i, 1)
						}
					}
				}
			},

			defeated1(val, index) { //通知方式的失败是否继续
				console.log(val);
				console.log(index);
				//				this.say();
			},
			S4() {
				return(((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
			},
			guid() {
				return(this.S4() + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + this.S4() + this.S4());
			}
		}
	}
</script>

<style scoped>
	.setTactics input,
	.setTactics textarea {
		border: 0;
	}
	
	.setTactics .el-input__inner {
		height: 30px;
	}
	
	textarea {
		resize: none !important;
		font-size: 12px;
		font-family: "微软雅黑";
	}
	
	.line {
		border-bottom: 1px solid #e0e3e9;
	}
	
	.setTactics .el-dialog__body {
		padding: 0 20px;
	}
	
	.el-main {
		padding: 0;
	}
	
	.caption {
		display: inline-block;
		line-height: 31px;
	}
	
	.setTactics .el-input,
	.setTactics .el-textarea {
		width: 70%
	}
	
	.headline {
		height: 20px;
		margin-bottom: 15px;
	}
	
	.headline div,
	.headline span {
		line-height: 20px;
		font-weight: bold;
		height: 20px;
		color: #409eff;
	}
	
	.caption_line {
		border-left: 2px solid #409eff;
		margin-right: 10px;
	}
	
	.chk {
		height: 32px;
		line-height: 32px;
	}
	
	.setTactics .min {
		width: 66px;
		height: 32px;
		text-align: center;
	}
	
	.setTactics .min2 {
		width: 88px;
		height: 32px;
		text-align: center;
	}
	
	.three,
	.two {
		margin-top: 20px;
	}
	
	.three .el-button {
		padding: 0 5px;
	}
	
	.upgrade_head {
		background-color: #eeeeee;
		padding-left: 10px;
	}
	
	.time .el-input__inner,
	.upgrade_head .el-input__inner {
		text-align: center;
	}
</style>